export enum IncomeType {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE',
}
